import type {
  BaseTokenInfo,
  SupportedChainName,
  TokenDeployment,
  TokenInfo,
} from "../../types/base"
import { getDerivedToken } from "../tokenUtils"
import { isEvmAddress } from "../validateAddress"

function isCaseInsensitiveAddress(address: string): boolean {
  return isEvmAddress(address) || /^(bc1|tb1)/i.test(address)
}

function deploymentMatchesAddress(
  deployment: TokenDeployment,
  tokenAddress: string | null
): boolean {
  if (tokenAddress === null) {
    return "type" in deployment && deployment.type === "native"
  }
  if ("type" in deployment) return false
  return isCaseInsensitiveAddress(tokenAddress)
    ? deployment.address.toLowerCase() === tokenAddress.toLowerCase()
    : deployment.address === tokenAddress
}

function tokenHasDeploymentForAddress(
  derived: BaseTokenInfo,
  chain: SupportedChainName,
  tokenAddress: string | null
): boolean {
  return derived.deployments.some(
    (d) => d.chainName === chain && deploymentMatchesAddress(d, tokenAddress)
  )
}

export function findTokenByAddress({
  chain,
  tokenAddress,
  tokenList,
}: {
  chain: SupportedChainName
  tokenAddress: string | null
  tokenList: TokenInfo[]
}): TokenInfo | null {
  for (const token of tokenList) {
    const derived = getDerivedToken(token, chain)
    if (derived && tokenHasDeploymentForAddress(derived, chain, tokenAddress)) {
      return token
    }
  }
  return null
}
